import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { fetchPranthList } from './pranthService'; // Adjust path as needed



const ListJilla = () => {

  const handleRedirect = () => {
    navigate("/createfranchise");
  }

  const [Jillas, setJillas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const JillasPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [pranthList, setPranthList] = useState([]);
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState("");
  const [selectedVibhagId, setSelectedVibhagId] = useState("");


  // const fetchPranthList = async () => {
  //   try {
  //     const res = await axiosPrivate.get("list-pranths");
  //     setPranthList(res.data);
  //   } catch (err) {
  //     console.error("Failed to fetch pranths", err);
  //     setPranthList([
  //       { id: "1", name: "ഉത്തര കേരളം" },
  //       { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     ]);
  //   }
  // };

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);


  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };




  const fetchJilla = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      setJillas(Array.isArray(res.data) ? res.data : []);
      setLoading(false);
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillas([]);
      setLoading(false);
    }
  }, [axiosPrivate, selectedVibhagId]);




  const handleViewClick = (JillaId) => {
    // Navigate to the GetJilla component with JillaId as a URL parameter
    navigate(`/GetFranchise/${JillaId}`);
  };
  const handleEditClick = (JillaId) => {
    navigate(`/UpdateFranchise/${JillaId}`);
  };

  useEffect(() => {
    fetchPranthList();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedVibhagId(vibhags[0].vibhag_id); // this will trigger table refresh
        } else {
          setSelectedVibhagId("");      // clear selection
          setJillas([]);            // clear table
          setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);


  useEffect(() => {
    if (selectedVibhagId) {
      setError(null);
      setLoading(true);
      fetchJilla();
    }
  }, [selectedVibhagId]);



  const indexOfLastJilla = currentPage * JillasPerPage;
  const indexOfFirstJilla = indexOfLastJilla - JillasPerPage;
  const currentJilla = Jillas.slice(indexOfFirstJilla, indexOfLastJilla);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(Jillas.length / JillasPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Jilla</button> */}
          <h3>Jilla List</h3>
          <Row className="mb-3">
            <Col md={2}></Col>
            <Col md={4}>
              <Form.Label className="newformstyle">Select Pranth</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedPranthId}
                onChange={(e) => setSelectedPranthId(e.target.value)}
              >
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={4}>
              <Form.Label className="newformstyle">Select Vibhag</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedVibhagId}
                onChange={(e) => setSelectedVibhagId(e.target.value)}
                disabled={!vibhagList.length}
              >
                <option value="">-- Select Vibhag --</option>
                {/* {vibhagList.map((v) => (
                  <option key={v.vibhag_id} value={v.vibhag_id}>
                    {v.vibhag_name}
                  </option>
                ))} */}
                {Array.isArray(vibhagList) && vibhagList.map((v) => (
                  <option key={v.vibhag_id} value={v.vibhag_id}>
                    {v.vibhag_name}
                  </option>
                ))}

              </Form.Select>
            </Col>
            <Col md={2}></Col>
          </Row>
          <div className="table-container">
            <table id="customers">
              <thead>
                <tr>
                  <th>Jilla ID</th>
                  <th>Jilla Name</th>
                  <th>Jilla Name (MALAYALAM)</th>
                  <th>Vibhag Name</th>
                  {/* <th>Options</th> */}
                </tr>
              </thead>
              <tbody>
                {error ? ( // If there's an error
                  <tr>
                    <td colSpan="6" className="text-danger text-center">
                      {error} {/* Show the error inside the table */}
                    </td>
                  </tr>
                ) : Jillas.length === 0 ? ( // If no data
                  <tr>
                    <td colSpan="6">No jillas available.</td>
                  </tr>
                ) : ( // If there is data
                  currentJilla.map(Jilla => (
                    <tr key={Jilla.jilla_id}>
                      <td>{Jilla.jilla_id}</td>
                      <td>{Jilla.search_tag}</td>
                      <td>{Jilla.jilla_name}</td>
                      <td>{Jilla.vibhag_name}</td>
                      {/* <td>
                        <div className="d-flex justify-content-center">
                          <button
                            type="button"
                            className="btn btn-warning btn-ico newicobtn"
                            onClick={() => handleEditClick(Jilla.jilla_id)}
                          >
                            <i className="bx bxs-edit icon"></i>
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  ))
                )}
              </tbody>

            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListJilla;
